export const GooglePaymentMethodName = "GooglePay";

export const GooglePaymentMethodWalletSource = "GOOGLEPAY";
